var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 1600 1200" },
      attrs: {
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0",
        y: "0",
        viewBox: "0 0 1600 1200",
        "xml:space": "preserve",
      },
    },
    [
      _c("g", { attrs: { transform: "matrix(2.27407 0 0 2.25714 914 82)" } }, [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_1_", d: "M-281.6-71.7h698.1v178.3h-698.1z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_2_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_1_" },
          }),
        ]),
        _c("g", { staticStyle: { "clip-path": "url(#SVGID_2_)" } }, [
          _c("ellipse", {
            staticClass: "st1",
            attrs: { cx: "117.5", cy: "17.5", rx: "39.8", ry: "39.5" },
          }),
          _c("ellipse", {
            staticClass: "st2",
            attrs: { cx: "117.5", cy: "17.5", rx: "21.5", ry: "21.4" },
          }),
          _c("path", { staticClass: "st2", attrs: { d: "M0 16h120v2H0z" } }),
        ]),
      ]),
      _c("path", {
        staticClass: "st3",
        attrs: { d: "M-29.7 858.6h666.3v172.8H-29.7z" },
      }),
      _c("g", [
        _c("ellipse", {
          staticClass: "st1",
          attrs: { cx: "303.5", cy: "834.3", rx: "86.5", ry: "86.4" },
        }),
        _c("ellipse", {
          staticClass: "st2",
          attrs: { cx: "303.5", cy: "834.3", rx: "46.6", ry: "46.7" },
        }),
        _c("path", {
          staticClass: "st2",
          attrs: { d: "M300.2 829.4h4.5v264.2h-4.5z" },
        }),
      ]),
      _c("g", { attrs: { transform: "matrix(2.28889 0 0 2.25714 284 792)" } }, [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_3_", d: "M-286.1-71.7h707.3v178.3h-707.3z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_4_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_3_" },
          }),
        ]),
        _c("g", { staticStyle: { "clip-path": "url(#SVGID_4_)" } }, [
          _c("ellipse", {
            staticClass: "st1",
            attrs: { cx: "117.5", cy: "17.5", rx: "40.1", ry: "39.5" },
          }),
          _c("ellipse", {
            staticClass: "st2",
            attrs: { cx: "117.5", cy: "17.5", rx: "21.7", ry: "21.4" },
          }),
          _c("path", { staticClass: "st2", attrs: { d: "M0 16h120v2H0z" } }),
        ]),
      ]),
      _c("path", {
        staticClass: "st3",
        attrs: { d: "M404 919.3h90.9v148.4H404z" },
      }),
      _c("path", {
        staticStyle: { fill: "#ebecec" },
        attrs: {
          d: "M500.3 972.1c0-27.9-22.8-50.6-50.8-50.6s-50.8 22.6-50.8 50.6c0 15.9 8.6 27.1 16.8 39.3 11.1 16.7 15.3 30.2 15.5 38.8h37c.7-9.7 5.9-26.7 15.5-38.8 10.9-13.7 16.8-23.4 16.8-39.3z",
        },
      }),
      _c("path", {
        staticClass: "st2",
        attrs: {
          d: "M430.5 1072.2h43.2l-2.1-6.9h-43.2zM463.3 1038l-33.5 10h36.5zM435.7 1089.2l39.2-11.8h-42.8zM424.8 1053.2l2.1 6.9H470l-2-6.9z",
        },
      }),
      _c("path", {
        staticClass: "st6",
        attrs: {
          d: "M466.3 1048h-36.5l-6.1 1.8 1.1 3.4H468zM428.4 1065.3h43.2l-1.6-5.2h-43.1zM432.1 1077.4h42.8l.4-.1-1.6-5.1h-43.2z",
        },
      }),
      _c("path", {
        staticClass: "st7",
        attrs: {
          d: "M440.8 1081.7h17.3v17.3h-17.3zM448.4 1060.5c-.3 0-.5-.2-.5-.6.7-26.9.6-55-7.3-80.9-.7-.4-1.3-.9-2-1.4-3.7-3-11.7-10.4-8.2-16.4.4-.6.9-.9 1.5-.8 1.8.1 3.9 3.1 4.6 4.6 1.9 4.4 3.6 8.9 4.9 13.4 4.3 2.6 9.6 3.7 14.6 3 1.9-.3 3.7-.8 5.4-1.7.6-2.7 1.2-5.3 1.8-7.9l.1-.4c.6-2.7 1.7-6.7 4.5-6 .8.2 1.5.7 1.8 1.5 1 2.1-.1 5.7-1.1 7.5-1.3 2.5-3.6 4.6-6.3 6.1-3.5 16.2-5.1 32.9-5.1 49.5 0 .3-.2.5-.5.5s-.5-.2-.5-.5c-.1-16.5 1.6-32.8 4.9-49-1.5.6-3.2 1.1-4.9 1.4-4.9.8-9.9-.2-14.3-2.5 7.6 25.7 7.7 53.5 7 80.1.1.2-.1.5-.4.5zm19-94.3c-1.6 0-2.5 3.2-3 5.3l-.1.4c-.6 2.3-1.1 4.6-1.6 7 2.3-1.3 4-3.1 5.1-5.2 1.1-2 1.8-5.1 1.1-6.5-.2-.5-.6-.8-1.1-.9-.3-.1-.3-.1-.4-.1zm-35.5-4.8c-.1 0-.4.1-.5.4-3.1 5.3 4.5 12.3 8 15.1.3.2.6.4.8.6-1.3-4.1-2.8-8.1-4.5-12.1-.8-1.7-2.7-4-3.8-4zM406.1 925.3h6.8v6.8h-6.8z",
        },
      }),
      _c("path", {
        staticClass: "st2",
        attrs: { d: "m414 912.9-5.2 4.8-4.8-5.3 5.2-4.8z" },
      }),
      _c("path", {
        staticClass: "st7",
        attrs: { d: "m482.6 896.1-8.1 8-8.1-8 8.1-8.1z" },
      }),
      _c("path", {
        staticClass: "st2",
        attrs: { d: "m478.2 917.9-2.5-5.1 5.2-2.6 2.5 5.2z" },
      }),
      _c("path", {
        staticClass: "st8",
        attrs: {
          d: "M482.2 1035h-.1c-.3-.1-.4-.4-.4-.6 4.7-15.1 16.8-28 31.6-33.7.3-.1.6 0 .7.3.1.3 0 .6-.3.7-14.5 5.6-26.4 18.2-30.9 33-.2.2-.3.3-.6.3z",
        },
      }),
      _c("path", {
        staticClass: "st7",
        attrs: {
          d: "M468.7 922.5c-.4-.1-.6-.3-.5-.6.6-4.6 3.2-9.8 6.5-12.6 3-2.5 5.7-3.7 10.2-4.4.3-.1.6.1.6.4.1.3-.1.6-.4.6-4.4.7-6.9 1.8-9.7 4.2-3 2.6-5.6 7.5-6.1 11.9-.1.3-.3.5-.6.5z",
        },
      }),
      _c("path", {
        staticClass: "st8",
        attrs: {
          d: "M456.2 911.8h-.2c-.3-.1-.4-.4-.3-.6 2.3-6.2 4.9-13.2 3.5-20-.1-.3.1-.6.4-.6.3-.1.6.1.6.4 1.5 7.1-1.2 14.2-3.5 20.5-.1.2-.3.3-.5.3z",
        },
      }),
      _c("path", {
        staticClass: "st2",
        attrs: {
          d: "M403.6 939.8c-.2 0-.4-.1-.4-.3-4.2-7.2-9.7-10.3-17.6-9.9-.3 0-.6-.2-.6-.5s.2-.6.5-.6c8.3-.4 14.2 3 18.5 10.5.1.3.1.6-.2.7 0 0-.1.1-.2.1z",
        },
      }),
      _c("path", {
        staticClass: "st3",
        attrs: { d: "M205.1 603h670.8v173.9H205.1z" },
      }),
      _c("g", [
        _c("ellipse", {
          staticClass: "st1",
          attrs: { cx: "540.5", cy: "578.5", rx: "86.9", ry: "87" },
        }),
        _c("circle", {
          staticClass: "st2",
          attrs: { cx: "540.5", cy: "578.5", r: "47" },
        }),
        _c("path", {
          staticClass: "st2",
          attrs: { d: "M537.2 572.7h4.5v267.8h-4.5z" },
        }),
      ]),
      _c("g", [
        _c("g", { attrs: { transform: "translate(1107 217) scale(2.0375)" } }, [
          _c("defs", [
            _c("path", {
              attrs: { id: "SVGID_5_", d: "M-126.1-126.1H206V206h-332.1z" },
            }),
          ]),
          _c("clipPath", { attrs: { id: "SVGID_6_" } }, [
            _c("use", {
              staticStyle: { overflow: "visible" },
              attrs: { "xlink:href": "#SVGID_5_" },
            }),
          ]),
          _c(
            "g",
            { staticStyle: { "clip-path": "url(#SVGID_6_)" } },
            [
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_7_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-583.299",
                    y1: "447.827",
                    x2: "-420.299",
                    y2: "447.827",
                    gradientTransform:
                      "matrix(2.0375 0 0 -2.0375 1188.472 952.448)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("circle", {
                staticStyle: { fill: "url(#SVGID_7_)" },
                attrs: { cx: "40", cy: "40", r: "40" },
              }),
              _c("circle", {
                staticClass: "st1",
                attrs: { cx: "40", cy: "40", r: "26" },
              }),
              _c("circle", {
                staticClass: "st2",
                attrs: { cx: "40", cy: "40", r: "10" },
              }),
              _c("path", {
                staticStyle: {
                  opacity: ".51",
                  fill: "#fff",
                  "enable-background": "new",
                },
                attrs: {
                  id: "texure_2_-i5",
                  d: "M43.7 28.2c.1 0 .3 0 .4-.2s0-.3-.2-.4c-.1 0-.3 0-.4.2 0 .1.1.3.2.4zm2.2-6.5c.2 0 .3 0 .4-.2 0-.1 0-.3-.2-.3-.1-.1-.3 0-.3.1-.1.2-.1.3.1.4zM72.1 26c.1.1.2.2.4.1.1-.1.2-.2.1-.3-.1-.1-.2-.2-.4-.1-.1-.1-.1.1-.1.3zm-38.9-8.1c.1.1.3.1.4 0 .1-.1.1-.3 0-.4s-.3-.1-.4 0c-.2.1-.2.3 0 .4-.1 0 0 0 0 0zm24.5 8.2c0 .2.2.3.3.3.2 0 .3-.2.3-.3 0-.2-.2-.3-.3-.3-.2.1-.3.2-.3.3zm-.5-6.8c0 .2.2.3.3.2.1 0 .3-.1.3-.3 0-.2-.2-.3-.3-.3-.2.2-.3.3-.3.4zM6.9 32.6c.2.2.5.2.7 0 .2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7zm9.1-9.2c.2.2.5.2.8 0 .2-.2.2-.5 0-.8-.2-.2-.5-.2-.7 0-.3.3-.3.6-.1.8zM47.9 62c0 .3.2.5.5.5s.5-.2.5-.5-.2-.5-.5-.5c-.2 0-.5.2-.5.5zm-.1-25.8c0 .3.2.5.5.5s.5-.2.5-.5-.2-.5-.5-.5c-.3-.1-.5.2-.5.5zm-.1-13c0 .3.2.5.5.5s.5-.2.5-.5-.2-.5-.5-.5c-.2 0-.5.2-.5.5zm-25.2 28c.3.1.6 0 .7-.3s0-.6-.3-.7c-.3-.1-.6 0-.7.3s.1.6.3.7zm4.9-11.9c.3.1.6 0 .7-.3s0-.6-.3-.7c-.3-.1-.6 0-.7.3-.1.2 0 .5.3.7zm4.9-12c.3.1.6 0 .7-.3.1-.3 0-.6-.3-.7s-.6 0-.7.3c-.1.3 0 .6.3.7zm39.3 23.8c.1.3.4.4.7.3.3-.1.4-.4.3-.7-.1-.3-.4-.4-.7-.3-.3.1-.4.5-.3.7zm-10-23.8c.1.3.4.4.7.3.3-.1.4-.4.3-.7-.1-.3-.4-.4-.7-.3-.3.1-.4.4-.3.7zM11 46.1c.2.1.5 0 .6-.2s0-.5-.2-.6-.5 0-.6.2c-.2.2-.1.5.2.6zm5.3-10.2c.2.1.5 0 .6-.2s.1-.5-.2-.6c-.2-.1-.5-.1-.6.2-.1.2 0 .5.2.6zm5.2-10.5c0 .1.1.2.2.3.2.1.5 0 .6-.2s0-.5-.2-.7c-.1-.1-.3-.1-.5 0-.1 0-.1.1-.2.2 0 .2 0 .3.1.4zM59 50.2c.1.3.4.4.6.3.2-.1.4-.3.3-.6-.1-.3-.3-.4-.6-.3-.3.1-.4.4-.3.6zm-6.9-22c.1.3.3.4.6.3.2-.1.4-.3.3-.5-.1-.3-.3-.4-.6-.3-.2 0-.3.3-.3.5zm-3.4-11c.1.3.4.4.6.3.2-.1.4-.3.3-.6-.1-.2-.3-.4-.6-.3-.2.1-.4.4-.3.6zM34 46.8c0 .3.2.5.4.5.3 0 .5-.2.5-.4 0-.3-.2-.5-.4-.5-.3 0-.5.2-.5.4zm1-11.4c0 .2.1.5.4.5.3 0 .5-.2.5-.4 0-.3-.2-.5-.4-.5-.2-.1-.5.1-.5.4zm1.1-11.5c0 .3.2.5.4.5.3 0 .5-.2.5-.4 0-.3-.2-.5-.4-.5-.3-.1-.5.1-.5.4zm32.8 1.7c.2.2.5.2.7.1.2-.2.2-.5 0-.7s-.5-.2-.7-.1c-.2.1-.2.4 0 .7 0-.1 0 0 0 0zm-32-.2c0 .2.2.3.3.2.2 0 .3-.2.2-.3 0-.2-.2-.3-.3-.2-.1 0-.2.1-.2.3zm-.7-6.8c0 .2.2.3.3.2.2 0 .3-.2.2-.3 0-.1-.1-.3-.3-.2-.1 0-.2.2-.2.3zm-12.8 2.1c.1 0 .3 0 .3-.2 0-.1 0-.3-.2-.3-.1 0-.3 0-.3.2-.1.1 0 .3.2.3zM49 18c.1.1.2.2.4.1.1-.1.2-.2.1-.4-.1-.1-.2-.2-.3-.1-.2.1-.2.2-.2.4zM5.3 24.7c.1.1.3 0 .4-.1.1-.1 0-.3-.1-.4-.1-.1-.3 0-.4.1-.2.1-.1.3.1.4zm32.3 3.1c0 .2.2.3.4.2.2-.1.3-.2.2-.4-.1-.2-.2-.3-.4-.2-.2 0-.3.2-.2.4zm-2.3-7.4c.1.2.2.3.4.2.2-.1.3-.2.2-.4-.1-.2-.2-.3-.4-.2-.1 0-.2.2-.2.4zm-13.8 5h.1c.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.4-.2 0-.3.1-.3.3 0 .3 0 .4.2.4zm28.3-8.3c.1.1.3.2.4 0 .1-.1.2-.3 0-.4-.1-.1-.3-.2-.4-.1 0 .1-.1.3 0 .5zM11.6 58.3c0 .3.2.6.5.6s.6-.2.6-.5-.2-.6-.5-.6-.5.2-.6.5zm1.1-13.2c0 .3.2.6.5.6s.6-.2.6-.5-.2-.6-.5-.6c-.3-.1-.5.2-.6.5zm1.1-13.3c0 .3.2.6.5.6s.6-.2.6-.5-.2-.6-.5-.6-.6.2-.6.5zm42.6-.4c.2.2.5.3.8.1.2-.2.3-.5.1-.8-.2-.2-.5-.3-.8-.1-.2.2-.3.6-.1.8zm-8.6-10.1c.2.2.5.3.8.1.2-.2.3-.6.1-.8-.2-.2-.6-.2-.8 0-.2.1-.3.4-.1.7zM33.1 36.9c.1.3.4.5.7.4.3-.1.4-.4.3-.7-.1-.3-.4-.5-.7-.4-.2.1-.4.4-.3.7zM29 24.3c.1.3.4.4.7.4.3-.1.5-.4.4-.7-.1-.3-.4-.5-.7-.4-.3 0-.4.3-.4.7 0-.1 0-.1 0 0zm-3.1 17.4c.1.3.4.5.7.4.3-.1.5-.4.4-.7s-.4-.5-.7-.4c-.3.1-.4.4-.4.7zm-3.5-12.8c.1.3.4.5.7.4.3-.1.5-.4.4-.7-.1-.3-.4-.5-.7-.4-.3.1-.4.4-.4.7zM3.1 36c0 .3.2.6.5.6s.6-.2.6-.5-.2-.6-.5-.6-.6.2-.6.5zm1.6-13.2c0 .3.2.6.5.6s.6-.2.6-.5-.2-.6-.5-.6-.5.2-.6.5zm45.8 13.6c.2.2.5.3.8.1.2-.2.3-.5.1-.8-.2-.2-.5-.3-.7-.1-.3.2-.4.6-.2.8zM42.4 26c.2.2.5.3.8.1.2-.2.3-.5.1-.8-.2-.2-.5-.3-.7-.1-.4.2-.4.5-.2.8zm-14.3 5.6c.1.2.4.3.6.2.2-.1.3-.3.2-.5-.2-.3-.4-.3-.6-.3-.3.2-.3.4-.2.6zm-4.6-8.8c.1.2.4.3.6.2.2-.1.3-.4.2-.6-.1-.2-.4-.3-.5-.2-.4.1-.4.4-.3.6zM6.9 32.2c0 .2.2.4.4.4s.4-.2.4-.5c0-.2-.2-.4-.4-.4-.3.1-.4.2-.4.5zm-.9-10c0 .2.2.4.5.4.2 0 .4-.2.4-.4s-.2-.4-.4-.4c-.3 0-.5.2-.5.4z",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c("g", [
        _c("g", { attrs: { transform: "matrix(.51372 0 0 .51241 661 663)" } }, [
          _c("defs", [
            _c("path", {
              attrs: { id: "SVGID_8_", d: "M97.5 130.2h69.9v92.7H97.5z" },
            }),
          ]),
          _c("clipPath", { attrs: { id: "SVGID_9_" } }, [
            _c("use", {
              staticStyle: { overflow: "visible" },
              attrs: { "xlink:href": "#SVGID_8_" },
            }),
          ]),
          _c(
            "g",
            { staticStyle: { "clip-path": "url(#SVGID_9_)" } },
            [
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_10_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-2277.93",
                    y1: "-1106.692",
                    x2: "-2051.441",
                    y2: "-1106.692",
                    gradientTransform:
                      "matrix(.2639 0 0 .2626 619.838 466.772)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_10_)" },
                attrs: { d: "M18.7 18.7h226.5v315H18.7z" },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_11_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-1224.069",
                    y1: "-1449.489",
                    x2: "-1438.558",
                    y2: "-1287.497",
                    gradientTransform:
                      "matrix(.2639 0 0 .2626 619.838 466.772)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_11_)" },
                attrs: { d: "M38.2 38.2h226.5v315H38.2z" },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_12_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-2348.791",
                    y1: "-1177.914",
                    x2: "-2122.302",
                    y2: "-1177.914",
                    gradientTransform:
                      "matrix(.2639 0 0 .2626 619.838 466.772)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#eee" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#d6d7d8" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_12_)" },
                attrs: { d: "M0 0h226.5v315H0z" },
              }),
              _c("path", {
                staticClass: "st16",
                attrs: {
                  d: "M186 57h-74.5c-1.1 0-2-.9-2-2s.9-2 2-2H186c1.1 0 2 .9 2 2s-.9 2-2 2zm-84.5 0h-10c-1.1 0-2-.9-2-2s.9-2 2-2h10c1.1 0 2 .9 2 2s-.9 2-2 2zm-20 0h-50c-1.1 0-2-.9-2-2s.9-2 2-2h50c1.1 0 2 .9 2 2s-.9 2-2 2zM186 121.6h-74.5c-1.1 0-2-.9-2-2s.9-2 2-2H186c1.1 0 2 .9 2 2s-.9 2-2 2zm-84.5 0h-10c-1.1 0-2-.9-2-2s.9-2 2-2h10c1.1 0 2 .9 2 2s-.9 2-2 2zm-20 0h-50c-1.1 0-2-.9-2-2s.9-2 2-2h50c1.1 0 2 .9 2 2s-.9 2-2 2zM186 186.2h-74.5c-1.1 0-2-.9-2-2s.9-2 2-2H186c1.1 0 2 .9 2 2s-.9 2-2 2zm-84.5 0h-10c-1.1 0-2-.9-2-2s.9-2 2-2h10c1.1 0 2 .9 2 2s-.9 2-2 2zm-20 0h-50c-1.1 0-2-.9-2-2s.9-2 2-2h50c1.1 0 2 .9 2 2s-.9 2-2 2zM186 250.8h-74.5c-1.1 0-2-.9-2-2s.9-2 2-2H186c1.1 0 2 .9 2 2s-.9 2-2 2zm-84.5 0h-10c-1.1 0-2-.9-2-2s.9-2 2-2h10c1.1 0 2 .9 2 2s-.9 2-2 2zm-20 0h-50c-1.1 0-2-.9-2-2s.9-2 2-2h50c1.1 0 2 .9 2 2s-.9 2-2 2z",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c("path", {
        staticClass: "st3",
        attrs: {
          transform: "rotate(-62.541 657.528 565.492)",
          d: "M592.9 397H722v337H592.9z",
        },
      }),
      _c("g", [
        _c("ellipse", {
          staticClass: "st1",
          attrs: {
            transform: "rotate(-67.418 739.594 577.735)",
            cx: "739.6",
            cy: "577.7",
            rx: "54",
            ry: "53.8",
          },
        }),
        _c("ellipse", {
          staticClass: "st2",
          attrs: {
            transform: "rotate(-76.261 739.574 577.708)",
            cx: "739.6",
            cy: "577.7",
            rx: "29.2",
            ry: "29.1",
          },
        }),
        _c("path", {
          staticClass: "st2",
          attrs: {
            transform: "matrix(1 -.00382 .00382 1 -2.213 2.434)",
            d: "M529.2 578.7h212.9v2.8H529.2z",
          },
        }),
      ]),
      _c("path", {
        staticClass: "st3",
        attrs: { d: "m579.9 261.3 353.7 190.4-73.5 135-353.8-190.4z" },
      }),
      _c("g", [
        _c("ellipse", {
          staticClass: "st1",
          attrs: {
            transform: "rotate(-15.598 734.09 334.957)",
            cx: "733.9",
            cy: "334.9",
            rx: "64.4",
            ry: "64.1",
          },
        }),
        _c("ellipse", {
          staticClass: "st2",
          attrs: {
            transform: "rotate(-33.382 733.91 334.919)",
            cx: "733.9",
            cy: "334.9",
            rx: "34.9",
            ry: "34.7",
          },
        }),
        _c("path", {
          staticClass: "st2",
          attrs: { d: "m737.2 563.8-3-.1.4-231.5 3.1.2z" },
        }),
      ]),
      _c("path", {
        staticClass: "st3",
        attrs: { d: "m1099.3 347.3-78.9 144.4-375.7-206.1 78.9-144.4z" },
      }),
      _c("g", [
        _c("ellipse", {
          staticClass: "st1",
          attrs: {
            transform: "rotate(-69.133 964.418 331.26)",
            cx: "964.4",
            cy: "331.3",
            rx: "68.8",
            ry: "68.5",
          },
        }),
        _c("ellipse", {
          staticClass: "st2",
          attrs: {
            transform: "rotate(-75.647 964.392 331.247)",
            cx: "964.4",
            cy: "331.3",
            rx: "37.2",
            ry: "37.1",
          },
        }),
        _c("path", {
          staticClass: "st2",
          attrs: { d: "m726.9 333.6.2-3.1 240.1 1.4-.2 3.2z" },
        }),
      ]),
      _c("path", {
        staticClass: "st3",
        attrs: { d: "m827.8 72 288.3 152.8-58 110.2-288.2-152.8z" },
      }),
      _c("g", [
        _c("ellipse", {
          staticClass: "st1",
          attrs: {
            transform: "rotate(-24.035 955.453 122.469)",
            cx: "955.4",
            cy: "122.5",
            rx: "51.9",
            ry: "52.1",
          },
        }),
        _c("ellipse", {
          staticClass: "st2",
          attrs: {
            transform: "matrix(.9993 -.03787 .03787 .9993 -3.954 36.271)",
            cx: "955.4",
            cy: "122.5",
            rx: "28.1",
            ry: "28.2",
          },
        }),
        _c("path", {
          staticClass: "st2",
          attrs: { d: "m958.5 330.3-2.7-.1.2-210.2 2.7.2z" },
        }),
      ]),
      _c("path", {
        staticClass: "st3",
        attrs: { d: "m431.6 1105.3-72.5 130.5-339.7-189.2 72.5-130.5z" },
      }),
      _c("g", [
        _c("ellipse", {
          staticClass: "st1",
          attrs: {
            transform: "rotate(-68.425 313.455 1090.368)",
            cx: "313.5",
            cy: "1090.3",
            rx: "62.4",
            ry: "62.1",
          },
        }),
        _c("ellipse", {
          staticClass: "st2",
          attrs: {
            transform: "rotate(-66.19 313.453 1090.32)",
            cx: "313.5",
            cy: "1090.3",
            rx: "33.7",
            ry: "33.5",
          },
        }),
        _c("path", {
          staticClass: "st2",
          attrs: { d: "m87.3 1091.8.1-2.9 228.7 2.1-.2 3z" },
        }),
      ]),
      _c("g", [
        _c("g", { attrs: { transform: "matrix(.99 0 0 .98788 826 420)" } }, [
          _c("defs", [
            _c("path", { attrs: { id: "SVGID_13_", d: "M3 2h294v161H3z" } }),
          ]),
          _c("clipPath", { attrs: { id: "SVGID_14_" } }, [
            _c("use", {
              staticStyle: { overflow: "visible" },
              attrs: { "xlink:href": "#SVGID_13_" },
            }),
          ]),
          _c(
            "g",
            { staticStyle: { "clip-path": "url(#SVGID_14_)" } },
            [
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_15_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-738.761",
                    y1: "688.947",
                    x2: "-101.776",
                    y2: "688.947",
                    gradientTransform:
                      "matrix(.392 0 0 .3904 312.224 -186.472)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_15_)" },
                attrs: { d: "M22.6 0h254.8v165H22.6z" },
              }),
              _c("path", {
                staticClass: "st6",
                attrs: { d: "M28.8 12.8h242.5v127.1H28.8z" },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_16_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-430.884",
                    y1: "701.498",
                    x2: "-148.889",
                    y2: "701.498",
                    gradientTransform:
                      "matrix(.392 0 0 .3904 312.224 -186.472)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#deeafe" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#0d93c5" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_16_)" },
                attrs: {
                  d: "M256.1 115H143.3V74.3c0-8 6.5-14.5 14.6-14.5h98.2V115zm-111.2-1.6h109.7V61.3h-96.7c-7.2 0-13 5.8-13 13v39.1z",
                },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_17_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-519.905",
                    y1: "744.145",
                    x2: "-237.911",
                    y2: "744.145",
                    gradientTransform:
                      "matrix(.392 0 0 .3904 312.224 -186.472)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#deeafe" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#0d93c5" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_17_)" },
                attrs: {
                  d: "M221.2 131.6H108.4V91c0-8 6.5-14.5 14.6-14.5h98.2v55.1zM110 130.1h109.7V78H123c-7.2 0-13 5.8-13 13v39.1z",
                },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_18_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-686.98",
                    y1: "572.275",
                    x2: "-147.485",
                    y2: "572.275",
                    gradientTransform:
                      "matrix(.392 0 0 .3904 312.224 -186.472)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#deeafe" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#0d93c5" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_18_)" },
                attrs: {
                  d: "M258.7 49.4H42.9V35.8c0-6.3 5.1-11.3 11.4-11.3h204.4v24.9z",
                },
              }),
              _c("path", {
                staticClass: "st2",
                attrs: { d: "M0 153.7h300V165H0z" },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_19_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-597.237",
                    y1: "568.176",
                    x2: "-563.844",
                    y2: "568.176",
                    gradientTransform:
                      "matrix(.392 0 0 .3904 312.224 -186.472)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#0d93c5" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_19_)" },
                attrs: { d: "M78.1 28.7h13.4V42H78.1z" },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_20_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-386.832",
                    y1: "689.075",
                    x2: "-353.44",
                    y2: "689.075",
                    gradientTransform:
                      "matrix(.392 0 0 .3904 312.224 -186.472)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#0d93c5" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_20_)" },
                attrs: { d: "M160.6 75.9H174v13.3h-13.4z" },
              }),
              _c("path", {
                staticClass: "st6",
                attrs: { d: "M78.4 30.5h3.7v3.6h-3.7z" },
              }),
              _c("path", {
                staticClass: "st7",
                attrs: { d: "M257.8 128.6h3.7v3.6h-3.7z" },
              }),
              _c("path", {
                staticStyle: { fill: "#f6f6f6" },
                attrs: { d: "M153.5 145h3.7v3.6h-3.7z" },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_21_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-576.4",
                    y1: "612.489",
                    x2: "-550.667",
                    y2: "612.489",
                    gradientTransform:
                      "matrix(.392 0 0 .3904 312.224 -186.472)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#0d93c5" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_21_)" },
                attrs: { d: "M86.3 47.5h10.3v10.3H86.3z" },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_22_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-272.227",
                    y1: "579.447",
                    x2: "-246.494",
                    y2: "579.447",
                    gradientTransform:
                      "matrix(.392 0 0 .3904 312.224 -186.472)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#0d93c5" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_22_)" },
                attrs: { d: "M205.5 34.6h10.3v10.3h-10.3z" },
              }),
              _c("path", {
                staticClass: "st7",
                attrs: { d: "M186.6 58h10.3v10.3h-10.3z" },
              }),
              _c("path", {
                staticStyle: { fill: "#e94a47" },
                attrs: { d: "M70.7 56.5h7.2v7.2h-7.2z" },
              }),
              _c("path", {
                staticClass: "st7",
                attrs: { d: "M135 70.3h7.2v7.2H135z" },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_23_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-571.176",
                    y1: "668.199",
                    x2: "-555.656",
                    y2: "668.199",
                    gradientTransform:
                      "matrix(.392 0 0 .3904 312.224 -186.472)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#0d93c5" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_23_)" },
                attrs: { d: "M88.3 71.3h6.2v6.2h-6.2z" },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_24_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-571.176",
                    y1: "772.449",
                    x2: "-555.656",
                    y2: "772.449",
                    gradientTransform:
                      "matrix(.392 0 0 .3904 312.224 -186.472)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#0d93c5" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_24_)" },
                attrs: { d: "M88.3 112h6.2v6.2h-6.2z" },
              }),
              _c("path", {
                staticClass: "st7",
                attrs: {
                  d: "M28.8 155.8h28.8v7.2H28.8zM67.7 155.8h19.9v7.2H67.7z",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c("g", [
        _c("g", { attrs: { transform: "matrix(1.30882 0 0 1.31 1183 436)" } }, [
          _c("defs", [
            _c("path", {
              attrs: { id: "SVGID_25_", d: "M-72.7-179h349.5v858H-72.7z" },
            }),
          ]),
          _c("clipPath", { attrs: { id: "SVGID_26_" } }, [
            _c("use", {
              staticStyle: { overflow: "visible" },
              attrs: { "xlink:href": "#SVGID_25_" },
            }),
          ]),
          _c(
            "g",
            { staticStyle: { "clip-path": "url(#SVGID_26_)" } },
            [
              _c("path", {
                staticClass: "st31",
                attrs: {
                  d: "M25.4 56.8C35.9 71.7 49.6 84.5 65.2 94c2.1-12.9-6.2-25.2-15.9-34s-25-19.1-28.5-26C16 24.6 11.4 12.3 5.1 2.7 3.4.1-1.1-1.3.2 1.5 3 7.3 5.9 11.1 7.7 17.6c-.7-.8-2.2-.1-2.5.9-.3 1-.3 2.7-.2 3.8.5 5.4-2.9 8.6-1 13.6 1.6 4.4 6.7 6.1 11 8.2 5 2.6 7.1 8 10.4 12.7z",
                },
              }),
              _c("path", {
                staticClass: "st2",
                attrs: {
                  d: "M86.1 196.8c1.2-4.9 3.3-9.5 5.3-14.1 1-2.2 2-4.5 3-6.7.4-.8.7-1.6 1.4-2.2.6-.5 1.4-.7 2.1-.8 8.4-1.7 17.4.1 24.5 4.9-2.4 13.2-1.1 27.1 3.6 39.7-12.7 5.4-26.3 8.5-40.1 9.2-1.1-10-2.3-20.2.2-30z",
                },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_27_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-875.645",
                    y1: "200.197",
                    x2: "-773.254",
                    y2: "200.197",
                    gradientTransform:
                      "matrix(1.3088 0 0 -1.31 1220.752 749.802)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_27_)" },
                attrs: {
                  d: "M114.1 476.1c7.7-1.5 32.3-.8 32.3-.8s6.6 14.8 6.5 24.6h-34.2c-19.2 0-23.7.2-44-.2-.4-4.6 8.7-12.9 25.2-16.8 3.7-.9 10.5-6.1 14.2-6.8z",
                },
              }),
              _c("path", {
                staticStyle: {
                  fill: "#151a4f",
                  stroke: "#000",
                  "stroke-width": "1.1158",
                  "stroke-miterlimit": "10",
                },
                attrs: {
                  d: "M116.8 289.3c-3.3-14.4-6.8-29.2-15.4-41.4-.9-1.3-2-2.6-3.6-2.8-3.1-.4-4.7 3.3-5.3 6.2-13.8 76.9 17.8 146.9 21.7 224.8 10 .6 22.6.9 32.6.6-2.7-16.1 4.3-20.3 3.6-36.6-.7-14.9-6.3-20.2-7.4-35.1-1.2-15.8 4.2-20.6.6-36-4.3-18.5-22.5-61.2-26.8-79.7z",
                },
              }),
              _c("path", {
                staticClass: "st31",
                attrs: {
                  d: "M169.1 195.6c-10.5 9.9-22.7 13.4-35.1 20.7-6.4-.2-5.5-.7-8.2-2.6-3.3-2.4-2.7-6.6-3.3-10.6-1.1-6.9-2.1-14.2.5-20.7 1.5 8.2 4.9 18.5 10.2 25 12.3-10.8 25.5-23.3 39.1-32.4.2 6.5.4 13 .6 19.4-.9-.5-3 1.8-3.8 1.2z",
                },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_28_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-836.603",
                    y1: "200.197",
                    x2: "-734.212",
                    y2: "200.197",
                    gradientTransform:
                      "matrix(1.3088 0 0 -1.31 1220.752 749.802)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_28_)" },
                attrs: {
                  d: "M165.2 476.1c7.7-1.5 32.3-.8 32.3-.8s6.6 14.8 6.5 24.6h-34.2c-19.2 0-23.7.2-44-.2-.4-4.6 8.6-12.9 25.2-16.8 3.6-.9 10.5-6.1 14.2-6.8z",
                },
              }),
              _c("path", {
                staticClass: "st7",
                attrs: {
                  d: "M163.7 177.5c-5.1-5-9.3-12.7-12.6-19.1-5.7-11.2-11.4-24-7.3-35.8 2.4-7 8.4-12.7 15.5-14.8-.5 11 3.3 21.8 7.1 32.1 5.5 14.7 10.4 26.2 16.4 40.7.8 1.8 2 5.9 1.5 6.9-2.3 4.3-4.6 7.6-8.4 8.5-3.8.8-8.2 1.7-10.1 5.1-5.7-6.4-8.8-9.7-7.2-18.2 3.1-2.9 4.1-3.4 5.1-5.4z",
                },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_29_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-123.537",
                    y1: "756.078",
                    x2: "326.705",
                    y2: "756.078",
                    gradientTransform:
                      "matrix(.2921 0 0 .2927 120.993 -74.948)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#0d93c5" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_29_)" },
                attrs: {
                  d: "M157.2 124.2c-5 10.8-16.3 22-22.4 32.3-10.2 17.3-10.6 21.1-13.6 40.9-12.1-.9-25.8-2.7-36.4 2.3 6.4-29 13.1-47.6 20.4-65.6 7.2-17.9 19.9-35.5 38.5-40.4 6.6-1.8 15.6-.6 17.7 5.9 1.2 3.6-2.6 21.3-4.2 24.6z",
                },
              }),
              _c("path", {
                staticStyle: { fill: "#f2a19c" },
                attrs: {
                  d: "M143.9 95.2c2.9 4 11.5 3.9 13.3 1.3-1.3-9 .2-16.1 3.4-24.6-5.2 2.2-10.7 3.5-16.3 3.9 2 6.6 2.1 12.9-.4 19.4z",
                },
              }),
              _c("path", {
                staticClass: "st31",
                attrs: {
                  d: "M142.2 51.4c.7 2.5-2.4 6.6-3.3 9-2.2 5.6-1.4 13 3.7 16 4.8 2.8 11 .6 15.6-2.5 3.9-2.6 7.5-5.8 9.9-9.8 2.4-4 3.4-9 2.1-13.5-.7-2.5-3-5.1-5.4-4.2.1-.6-2-.8-1.9-1.4-4.7-.8-7.6 0-11.3 3-2.3 1.8-3.1 2.9-6 2-1.3-.4-3.3-1.3-3.7 0 0 .5.1 1 .3 1.4z",
                },
              }),
              _c("path", {
                staticClass: "st8",
                attrs: {
                  d: "M174.6 49.4c-4.7-4.2-8.2-4.4-14.6-5-.2 6.4-4.6 11.9-8 17.3s-5.9 12.8-2.3 18.1c1.9 2.9 5.5 4.9 6.5 8.2.9 2.9-.2 5.9-.5 8.9-.8 9.9 3.6 20 11.2 26.3.5-5.2 6.9-7.6 12.1-7.5 5.2.1 10.8 1.4 15.4-1.1 4.9-2.6-.8-7.4 3.1-11.3 3.1-3.2-3-13.3-12.7-17.7-4.8-2.2-5.2-12.8-4-17.9 2-8-2.5-15-6.2-18.3z",
                },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_30_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-125.2",
                    y1: "1412.623",
                    x2: "556.59",
                    y2: "1412.623",
                    gradientTransform:
                      "matrix(.2921 0 0 .2927 120.993 -74.948)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#23286b" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#151a4f" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_30_)" },
                attrs: {
                  d: "M138.6 273.1c-1.3-3.9-2.7-12.7-2.2-16.8.3-2.6 1.5-4.9 1.9-7.5 1-5.2-1-10.5-3-15.5-4.4-10.9-8.8-21.7-13.1-32.6-12.7.8-25.4 2.9-37.7 6.1-2 96.6 33.2 184.2 80.7 269.3 7.8.6 24.3-1.2 32.1-.7 1 .1 6.5-16.6.7-35.3-2-6.4-11.9-19.5-14.1-25.8-3.1-8.7-5.4-25.4-6.4-34.6-2.4-22.5-17.7-25.5-22.6-47.6-2.2-9.6-11.9-46-16.3-59z",
                },
              }),
              _c("path", {
                staticClass: "st8",
                attrs: {
                  d: "M159 124c-.1 0-.2 0-.3-.1-2.1-1.2-4-2.8-5.5-4.7-2.1-2.6-3.3-5.5-3.5-8.4-.2-2.8.5-5.5 1.2-8.1.6-2.3 1.3-4.7 1.2-7.1-.1-3.6-1.9-8-3.7-12.3-.7-1.6-1.3-3.2-1.9-4.7-2.2-6.1-.6-9.8 2.1-14.8 1.1-2 2.6-4 4.3-6.1 2.8-3.5 5.7-7.2 6.1-10.8 0-.3.3-.5.6-.5s.5.3.5.6c-.4 3.9-3.4 7.7-6.3 11.4-1.6 2.1-3.2 4-4.2 5.9-3 5.6-3.9 8.7-2 14 .5 1.5 1.2 3 1.9 4.7 1.8 4.4 3.7 8.9 3.8 12.7.1 2.5-.6 5-1.2 7.4-.7 2.6-1.4 5.1-1.2 7.7.2 3.4 1.9 6.1 3.3 7.8 1.4 1.8 3.2 3.3 5.2 4.5.3.2.4.5.2.8-.3 0-.4.1-.6.1zM149.1 53.4h-.1c-2.1-.4-3.1-2.9-3-4.5 0-.3.3-.6.6-.5.3 0 .5.3.5.6-.1 1 .6 3 2.2 3.3.3.1.5.4.4.7-.1.2-.4.4-.6.4z",
                },
              }),
              _c("path", {
                staticClass: "st31",
                attrs: {
                  d: "M124.3 200.2c-1.1-1-2-2.3-3-3.4-1.4-1.5-3.2-2.6-4.9-3.7-.7-.5-1.5-.9-2.3-1.1-.4-.1-.9-.1-1.2.2-.7.7 0 1.8.7 2.5 2 1.9 4 3.9 6 5.8 1.3 1.2 2.5 2.4 3.4 4 .6 1.1 1.1 2.3 1.7 3.4.5.8 1.1 1.6 1.9 2 .9.4 2 .3 2.6-.5-1.2-2.1-.7-5-2.2-7-.7-.8-1.8-1.4-2.7-2.2z",
                },
              }),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "SVGID_31_",
                    gradientUnits: "userSpaceOnUse",
                    x1: "-257.712",
                    y1: "569.349",
                    x2: "223.113",
                    y2: "569.349",
                    gradientTransform:
                      "matrix(.2921 0 0 .2927 120.993 -74.948)",
                  },
                },
                [
                  _c("stop", {
                    staticStyle: { "stop-color": "#0d93c5" },
                    attrs: { offset: "0" },
                  }),
                  _c("stop", {
                    staticStyle: { "stop-color": "#a1e7fc" },
                    attrs: { offset: "1" },
                  }),
                ],
                1
              ),
              _c("path", {
                staticStyle: { fill: "url(#SVGID_31_)" },
                attrs: {
                  d: "M138.5 94.7c-18.1-3.6-46.9-7.9-53.9-9.8-2.7-.7-5.1-1.4-7.2-1.9-.8-1.2-8.1-5.3-8.7-5.9-3.9-4-6.9-6-10.6-10-4.7 3.3-8.9 9.3-16.3 16.8 3.9 3.8 13.6 5.3 17.9 8.7 2 1.6 4.1 3.2 6.5 3.8 1.3.7 2.6 1.4 4.2 2 5.4 2.2 40.3 12.8 47 14.6 6.7 1.7 17.8 5 26.4 2.1 1.8-.6 5.2-2.6 5.3-4.2.3-4.6-2.7-14.7-10.6-16.2z",
                },
              }),
              _c("path", {
                staticClass: "st6",
                attrs: {
                  id: "texture-2_3_-i13",
                  d: "M88.4 238.1c.1-.1 0-.3-.1-.3-.1-.1-.3 0-.3.1-.1.1 0 .3.1.3.2.1.2-.1.3-.1zm-.5-24.9c.1 0 .2-.2.2-.3 0-.1-.2-.2-.3-.2-.1 0-.2.2-.2.3-.1.3.2.3.3.2zm-.6 12.6c.1 0 .2-.1.3-.2 0-.1-.1-.2-.2-.3-.1 0-.2.1-.3.2 0 .2.1.3.2.3zm30.7 10.1c.3 0 .4-.1.5-.4 0-.3-.1-.4-.4-.5-.3 0-.4.1-.5.4-.1.3.2.6.4.5zm-11.2-.4c.3 0 .4-.1.5-.4 0-.3-.1-.4-.4-.5-.3 0-.4.1-.5.4 0 .2.2.4.4.5zm-11.2-.6c.3 0 .4-.1.5-.4 0-.3-.1-.4-.4-.5-.3 0-.4.1-.5.4-.1.3.1.4.4.5zm11.9 22.6c0-.3 0-.5-.2-.7-.3 0-.5 0-.7.2 0 .3 0 .5.2.6.3.3.6.2.7-.1zm-10.2-4.7c0-.3 0-.5-.2-.7-.3 0-.5 0-.7.2 0 .3 0 .5.2.6.3.2.6.1.7-.1zm12.4-37.9c.2-.1.4-.4.3-.6-.1-.2-.4-.4-.6-.3-.2.1-.4.4-.3.6.1.2.4.4.6.3zM99 218.7c.2-.1.4-.4.3-.6-.1-.2-.4-.4-.6-.3-.2.1-.4.4-.3.6.1.2.4.4.6.3zm-10.5 3.7c.2-.1.4-.4.3-.6-.1-.2-.4-.4-.6-.3-.2.1-.4.4-.3.6.1.4.4.4.6.3zm14 44.9c.1-.1.1-.5-.2-.6-.1-.1-.5-.1-.6.2-.1.1-.1.5.2.6.3.2.5.1.6-.2zm5.8-41.5c.2-.1.4-.3.3-.5s-.2-.3-.5-.3c-.2.1-.4.3-.3.5.1.2.2.4.5.3zm-9.7 2.5c.2-.1.4-.3.3-.5s-.2-.3-.5-.3c-.2.1-.4.3-.3.5.1.2.3.4.5.3zm-9.7 2.4c.2-.1.4-.3.3-.5-.1-.2-.2-.3-.5-.3-.2.1-.4.3-.3.5.1.3.2.4.5.3zm15.3 16.6c.3 0 .4-.1.5-.4 0-.3-.1-.4-.4-.5-.3 0-.4.1-.5.4 0 .3.2.6.4.5zm-9.9-1.3c.3 0 .4-.1.5-.3 0-.3-.1-.4-.4-.5-.3 0-.4.1-.5.4 0 .1.2.3.4.4zm1.1-35.9c.2-.2.3-.3.1-.5-.2-.2-.4-.2-.5-.1-.2.2-.2.4-.1.6 0 0 .3.1.5 0zm-8 5.9c.2-.2.2-.4.1-.6-.2-.2-.4-.2-.6-.1-.2.2-.2.4-.1.5.1.4.4.4.6.2-.1.1 0 0 0 0zm25.7 51.3c.3 0 .4-.1.5-.4 0-.3-.1-.4-.4-.5-.3 0-.4.1-.5.4 0 .3.2.5.4.5zm-11.4-1.5c.3 0 .4-.1.5-.4 0-.3-.1-.4-.4-.5-.3 0-.4.1-.5.4-.1.2.2.5.4.5zm-.6-45.7c.2-.2.2-.4.1-.6-.2-.2-.4-.2-.6-.1-.2.2-.2.4-.1.6 0 .3.4.3.6.1zm-9.3 7.1c.2-.2.2-.4.1-.6-.2-.2-.4-.2-.6-.1-.2.2-.2.4-.1.6.2.1.4.3.6.1zm14.9 17.5c.2-.1.4-.4.3-.6-.1-.2-.4-.4-.6-.3-.2.1-.4.4-.3.6.1.2.4.4.6.3zm-11.1 3c.2-.1.4-.4.3-.6-.1-.2-.4-.4-.6-.3-.2.1-.4.4-.3.6s.3.4.6.3zm15 3.9c.2-.1.4-.4.3-.6-.1-.2-.4-.4-.6-.3-.2.1-.4.3-.3.6s.4.4.6.3zm-11.3 2.5c.2-.1.4-.4.3-.6-.1-.2-.3-.4-.6-.3-.2.1-.4.4-.4.6.2.3.5.4.7.3zM96 232.6c.2-.2.2-.4.2-.7-.2-.2-.4-.2-.7-.2-.2.2-.2.4-.2.7.1.2.4.2.7.2z",
                },
              }),
              _c("path", {
                staticClass: "st8",
                attrs: {
                  d: "M138.5 108.8c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.8 3.3-3.7 5.6-7.2 7-10.7 1.7-4.2 2.1-8.7 1.1-12.5-.3-1.3-.8-2.5-1.3-3.8-.7-1.8-1.4-3.7-1.7-5.7-.7-6.2 3.4-11.9 7.1-16.1l1-1.1c3.6-4.1 7.2-8.3 8.1-13.4 0-.3.3-.5.6-.5s.5.3.5.6c-.9 5.5-4.7 9.8-8.3 14l-1 1.1c-3.5 4.1-7.5 9.5-6.8 15.3.2 1.9.9 3.6 1.6 5.5.5 1.3 1 2.5 1.3 3.9 1 4 .6 8.7-1.2 13.1-1.5 3.6-3.8 7.2-7.2 11.1-.1 0-.3.1-.4.1z",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }